import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { hrefFor } from '../../routers';
import { AccountOrderDetailPageState } from '../../constants';
import { Order } from '../../hooks/useOrder';

interface Props {
  orderNumber: string;
  order: Order;
}

export const AccountOrderActionPay: React.FC<Props> = ({ orderNumber, order }) => {
  if (!order || Number(order.attributes.totals.remainingBalance.price) <= 0) return null;

  return (
    <Stack alignItems="flex-start" space={1}>
      {!order.attributes.hasPendingAuthorizationItems && (
        <ControlLink
          to={hrefFor.OrderDetailPage({
            orderNumber,
            state: AccountOrderDetailPageState.Paying
          })}
        >
          <Text treatment="body2" color="ink">
            Pay Remaining Balance
          </Text>
        </ControlLink>
      )}
      {order?.attributes.isAddressChangeable && (
        <ControlLink
          to={hrefFor.OrderDetailPage({
            orderNumber: order?.attributes.orderNumber,
            state: AccountOrderDetailPageState.ChangingShippingAddress
          })}
        >
          <Text treatment="body2" color="ink">
            Change Shipping Address
          </Text>
        </ControlLink>
      )}
    </Stack>
  );
};
